@use '../../styles/tokens' as *;

.avatarContainer {
  height: 3.2rem;
  position: relative;
  width: 3.2rem;

  img {
    border-radius: 0.3rem;
  }
}

.online {
  background-color: $colorLightBlue;
  border: 1px solid $colorLightestBlue;
  border-radius: 50%;
  bottom: -0.2rem;
  height: 1rem;
  position: absolute;
  right: -0.4rem;
  width: 1rem;
}
